<div class="step-container">
  <h2 class="step-titulo">Como você vai vender?</h2>
  <p class="step-subtitulo">Selecione um ou mais modos de venda. Você pode alterar isso depois.</p>

  <div class="modos-grid">
    <div class="modo-card"
         *ngFor="let opcao of opcoes"
         [class.selecionado]="estaSelecionado(opcao.id)"
         (click)="toggle(opcao.id)">

      <div class="modo-check">
        <i class="fe-check" *ngIf="estaSelecionado(opcao.id)"></i>
      </div>

      <div class="modo-icone">
        <i [class]="opcao.icone"></i>
      </div>

      <h4 class="modo-titulo">{{ opcao.titulo }}</h4>
      <p class="modo-descricao">{{ opcao.descricao }}</p>
    </div>
  </div>

  <div class="step-actions">
    <button class="btn-anterior" (click)="voltar()">
      <i class="fe-arrow-left mr-1"></i> Anterior
    </button>
    <div class="d-flex flex-column align-items-end">
      <p class="text-danger mb-1" *ngIf="erroValidacao">
        <i class="fe-alert-circle mr-1"></i> {{ erroValidacao }}
      </p>
      <p class="text-danger mb-1" *ngIf="erroPersistencia">
        <i class="fe-alert-circle mr-1"></i> {{ erroPersistencia }}
      </p>
      <button class="btn-proximo" (click)="avancar()" [disabled]="salvando">
        {{ salvando ? 'Salvando...' : 'Próximo' }} <i class="fe-arrow-right ml-1" *ngIf="!salvando"></i>
      </button>
    </div>
  </div>
</div>
